export default async function loadRecaptcha(app) {
  const { recaptcha } = app.config;
  return Promise.resolve(recaptcha);
}
